<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hCKMMJ/tc-custom/9781913118419.jpg?1730238099354" alt="This image is the cover for the book Nicaragua, 1961–1990, Latin America at War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nicaragua, 1961–1990, Latin America at War
      </h1>
      <p class="bookDescription body article font2">
        <b>A history of the Sandinista takeover of this Central American nation and the uneasy decades leading up to it, with maps, photos, and illustrations.</b><br/>  <br/> In the wake of the US invasion of Nicaragua in 1912, the country came under the rule of the Somoza family, which imposed a brutal, corrupt military dictatorship. A low-scale insurgency of students, supported by peasants and other anti-Somoza elements of the society, had developed already in the 1960s. By the 1970s, the country was embroiled in revolt. Supported by Cuba, a coalition of students, farmers, businessmen, clergy, and a small group of Marxists launched a major war in 1978, which resulted in the downfall of the Somozas a year later.<br/>  <br/> The Sandinista government established in Managua in 1979 found the country ruined by the long war and natural disasters, and nearly half the population homeless or living in exile. Attempting to restructure and recover the underdeveloped economy, Sandinistas introduced a wide range of reforms and a cultural revolution.<br/>  <br/> Drawing on extensive studies of involved armed groups, and their insurgencies in the 1960s and 1970s, <i>Nicaragua, 1961-1990, Volume 1</i> provides in-depth coverage of military history during the first phase of one of major armed conflicts of Latin America in modern times. Moving meticulously through the details of involved forces, their ideologies, organization, and equipment, this book is an accurate, blow-by-blow account of the Nicaraguan War, illustrated with more than 120 photos, maps, and color artworks.<br/>  <br/> Also available is Volume 2 of this series, which focuses on the new war that raged through Nicaragua for most of the 1980s after the US, considering the Sandinistas “Cuban-supported Marxists” and thus a major threat to US domination of Latin America, began supporting the creation of the Contrarevolutionary forces (better known as Contras).<br/>  <br/> “A lavishly photo-illustrated and detailed chronological account of the Somoza military dictatorship in Nicaragua and its overthrow in 1979.” —<i>Perspectives on Terrorism</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Francois
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Helion and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?736b4312